import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const ice: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interior', 'steeringWheels'],
	showCaESummaryText: true,
	engineCardKeyfacts: ['maxPowerHp', 'acceleration', 'torque'],
};

const rs4avant: PartialCarConfiguration = {
	...ice,
};

const rs6avantperformance: PartialCarConfiguration = {
	...ice,
};

export { rs4avant, rs6avantperformance };
